import { compose } from 'redux';

// function stolen from https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/37511463#37511463
function removeAccents(str: string) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function toCamelCase(str: string) {
  return str.replace(/ (\w)/g, (_, p) => p.toUpperCase());
}

function toLowerCase(str: string) {
  return str.toLowerCase();
}

function trim(str: string) {
  return str.trim();
}

export const normalizeString = (str: string) => compose(toCamelCase, toLowerCase, trim, removeAccents)(str);
